var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"flex items-center"},[_c('img',{staticClass:"h3 mr3",attrs:{"src":require("../assets/logo-open-images-browser.png"),"alt":"Logo Open Images Browser"}}),_c('h1',{staticClass:"mv0 f1"},[_vm._v("Open Images Browser")])])])
}]

export { render, staticRenderFns }